import { SKIP_SUBSCRIPTION_VALIDATION } from '@/config/settings';
import { store } from '@/store';

const checkSubscriptionStatus = (subscription, statuses) => {
  if (SKIP_SUBSCRIPTION_VALIDATION) {
    return true;
  }

  // No subscription? Double check the store
  if (!subscription) {
    const state = store.getState();
    subscription = state.user?.subscription;
  }

  if (!subscription) {
    return false;
  }

  if (subscription?.subscriptionStatus === 'trialing') {
    return true;
  }

  // Is this the subscription status you were looking for?
  return statuses.indexOf(subscription.subscriptionStatus) !== -1;
};

export const hasValidSubscription = subscription => {
  return checkSubscriptionStatus(subscription, ['trialing', 'active']);
};

export const hasActiveSubscription = subscription => {
  return checkSubscriptionStatus(subscription, ['active']);
};

export const isTrialing = subscription => {
  return checkSubscriptionStatus(subscription, ['trialing']);
};

export const hasCancelled = subscription => {
  if (!subscription) {
    return false;
  }

  return (
    !subscription.currentPeriodEndUTC || subscription.hasHadActiveSubscription
  );
};
